import type { IntegrationTableColumn } from "../integration-status/integrationStatusColumns";
import type { BenefitsLogFilterState } from "../../manage-partner/partner-program/benefits-log/BenefitsLogFilterModal";

export type BenefitActivityColumnKey =
  | "plannedDate"
  | "deliveredDate"
  | "status"
  | "hidOwner"
  | "partnerOwner"
  | "comments";

export const BENEFIT_ACTIVITY_COLUMNS: IntegrationTableColumn[] = [
  { key: "plannedDate", label: "Planned Date" },
  { key: "deliveredDate", label: "Delivered Date" },
  { key: "status", label: "Status" },
  { key: "hidOwner", label: "HID Owner" },
  { key: "partnerOwner", label: "Partner Owner" },
  { key: "comments", label: "Comments/ Files" },
];

export const DEFAULT_VISIBLE_BENEFIT_ACTIVITY_COLUMNS: string[] =
  BENEFIT_ACTIVITY_COLUMNS.map((column) => column.key);

export const BENEFIT_ACTIVITY_STATUS_OPTIONS = [
  { label: "Delivered", value: "Delivered" },
  { label: "Ongoing", value: "Ongoing" },
  { label: "On Hold", value: "On Hold" },
  { label: "Overdue", value: "Overdue" },
  { label: "Pending", value: "Pending" },
];

/** KPI tile id -> status value sent to the dashboard API (null clears the filter). */
export const BENEFIT_ACTIVITY_TILE_STATUS: Record<string, string | null> = {
  total: null,
  delivered: "Delivered",
  inProgress: "Ongoing",
  overdue: "Overdue",
};

/**
 * `partner`, `benefitsName`, `hidOwner` and `partnerOwner` hold IDs; date ranges are `[from, to]`
 * (`yyyy-mm-dd`, either side may be ""). All filters are applied by the dashboard API.
 */
export type BenefitActivityFilterState = BenefitsLogFilterState;

export const EMPTY_BENEFIT_ACTIVITY_FILTER: BenefitActivityFilterState = {
  partner: [],
  category: [],
  benefitsName: [],
  status: [],
  hidOwner: [],
  partnerOwner: [],
  deliveredDateRange: [],
  plannedDateRange: [],
};

export const hasActiveBenefitActivityFilters = (
  filter: BenefitActivityFilterState
): boolean => Object.values(filter).some((values) => values.length > 0);
